/*
import { useSelector, useDispatch } from 'react-redux';
import { updateMessage,updateMessage2} from '../store/slice';

const message = useSelector((state:any) => state.message);
const dispatch = useDispatch();

dispatch(updateMessage("Hi.Mani.Saro.."));
console.log("message:",message);
*/
import { createSlice } from '@reduxjs/toolkit';

export const auto = createSlice({
  name: 'auto',
  initialState: {
    orderExtension: [],
    editCompanyName: {},
  },
  reducers: {
    updateOrderExtension: (state, actions) => {
      state.orderExtension = actions.payload;
    },
    updateEditCompanyName: (state, actions) => {
      state.editCompanyName = actions.payload;
    },
  }
});

export const {
    updateOrderExtension,
    updateEditCompanyName,
} = auto.actions

export default auto.reducer;
